// extracted by mini-css-extract-plugin
module.exports = {"description":"styles_description__Vv0wY","fadeInOut":"styles_fadeInOut__KoucR","loader":"styles_loader__VZmdc"};